import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { getIconSrc } from "../helpers/getImgSrc";

const NavigationLink = ({ option, tab, isOpenSidebar }) => {
  const location = useLocation();
  const [showSuboptions, setShowSuboptions] = useState(
    location.pathname.split("/").pop() == option?.path
  );
  let isOptionActive = location.pathname.split("/").pop() == option?.path;
  return (
    <li className={`pb-4 `} key={option?.label}>
      <div
        className={
          "d-flex justify-content-between align-items-center " +
          option?.label?.toLowerCase()
        }
      >
        {option?.enable ? (
          <NavLink
            style={{ lineHeight: 0 }}
            to={option?.path}
            end={option?.end}
            className={({ isActive }) =>
              `d-flex gap-4  align-items-center  ${isActive ? "active" : ""}`
            }
          >
            {/* <i className={option.icon_classnames}></i> */}
            {({ isActive }) => {
              return (
                <>
                  <img
                    src={isActive ? option.active : option.inactive}
                    alt=""
                    srcSet=""
                    style={{ height: "24px", width: "24px" }}
                  />
                  <span
                    className={`   ${
                      !isOpenSidebar && tab === "user_profile"
                        ? "d-none"
                        : "d-md-block"
                    }  
                    ${isActive ? "fs-6" : null}`}
                  >
                    {option.label}
                  </span>
                </>
              );
            }}
          </NavLink>
        ) : (
          <div
            className="d-flex gap-4 align-items-center subscription-nav-disabled"
            title={option?.disabledTitle ?? "This feature is coming soon"}
            style={{
              cursor: "not-allowed",
              opacity: 0.55,
            }}
          >
            <img
              src={option.inactive}
              alt=""
              srcSet=""
              style={{ height: "24px", width: "24px" }}
            />
            <span
              className={` ${
                !isOpenSidebar && tab === "user_profile"
                  ? "d-none"
                  : "d-md-block"
              } disable_link `}
            >
              {option.label}
            </span>
          </div>
        )}

        {option?.option_list &&
          option?.option_list.length > 0 &&
          tab !== "user_profile" &&
          (showSuboptions ? (
            <img
              src={getIconSrc("arrow-up")}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => {
                option?.enable && setShowSuboptions((prev) => !prev);
              }}
            ></img>
          ) : (
            <img
              img
              src={getIconSrc("arrow-down")}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => {
                option?.enable && setShowSuboptions((prev) => !prev);
              }}
            ></img>
          ))}
      </div>

      {showSuboptions && option?.option_list?.length > 0 && (
        <ul className="mt-2" style={{ marginLeft: "1rem" }}>
          {option?.option_list?.map((sub_option) => {
            if (sub_option?.disabled) {
              return (
                <li
                  key={sub_option.name}
                  className="d-flex gap-4 align-items-center py-2 subscription-nav-disabled"
                  title={sub_option?.disabledTitle ?? "Subscribe to unlock"}
                  style={{ cursor: "not-allowed", opacity: 0.55 }}
                >
                  <span
                    className={`${tab !== "user_profile" ? "d-md-block" : "d-none"}`}
                  >
                    {sub_option?.name}
                  </span>
                </li>
              );
            }

            return (
              <NavLink
                to={sub_option?.path}
                key={sub_option.name}
                className={({ isActive }) =>
                  `d-flex gap-4 align-items-center py-2  ${
                    isActive ? "active" : ""
                  }`
                }
                end
              >
                {({ isActive }) => {
                  return (
                    <span
                      className={` ${isActive ? "fs-6" : null}  ${
                        tab !== "user_profile" ? "d-md-block" : "d-none"
                      }  `}
                    >
                      {sub_option?.name}
                    </span>
                  );
                }}
              </NavLink>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default NavigationLink;
